import SessionEventProto from "../session-event-proto";
import Company from "../../model2/company/company";

export default class SessionEvent_CompanyChange extends SessionEventProto {


    constructor(sessionEvent:any) {
        super(sessionEvent)
    }


    process() {

        const sessionCompany = gd.session.companies.get(this.data.id)
        if (!sessionCompany) return

        const tempCompany = new Company(this.data); // required for proper color and abbreviation parse

        sessionCompany.name         = tempCompany.name
        sessionCompany.icon         = tempCompany.icon
        sessionCompany.settings     = tempCompany.settings
        sessionCompany.finance      = tempCompany.finance
        sessionCompany.workWeek     = tempCompany.settings.workSchedule.workWeek
        sessionCompany.color        = tempCompany.color
        sessionCompany.abbreviation = tempCompany.abbreviation


        gd.bus.triggerEvent("company:profile:changed");

    }
}



//
// import MyCompany from 'core/gd-model/company/my-company';
// import Company from "../../model2/company/company";
//
// const EventCompanyChange = function(uid,data) {
//     this.data = data;
//     this.uid = uid;
// };
//
// EventCompanyChange.prototype.validate = function(){
//     return true;
// };
//
// EventCompanyChange.prototype.process = function(){
//
//     const sessionCompany = gd.session.companies.get(this.data.id);
//
//     const company = new MyCompany(this.data, {parse:true}); // required for proper color and abbreviation parse
//
//     sessionCompany.set({
//         name:           company.name,
//         icon:           company.icon,
//         settings:       company.settings,
//         finance:        company.finance,
//         workWeek:       company.settings.workSchedule.workWeek,
//         color:          company.color,
//         abbreviation:   company.abbreviation,
//     },{silent:false});
//
//
//     gd.bus.triggerEvent("company:profile:changed");
// };
//
//
// module.exports = EventCompanyChange;

